<template>
  <el-dialog title="自动合并订单设置"
  :visible.sync="mergeOrderDialogVisible" 
  :close-on-click-modal="false"
  width="550px"
  >
  <div v-loading="loading">
    <div class="padding-top-bottom-10">
      <el-checkbox class="font-size-14" @change="autoFlagFn" v-model="autoFlag">自动合并订单</el-checkbox>
    </div>
    <div class="auto-setting">
      <div class="padding-top-bottom-10 font-weight">自定义合并数量：</div>
      <div class="padding-top-bottom-10">满足条件时，最多每
        <el-select v-model="settingNum" :disabled="!autoFlag" placeholder="请选择">
          <el-option
            v-for="item in 20"
            v-if="item>1"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select> 笔订单自动合并成一笔订单。   
      </div>
      <div class="padding-top-bottom-10 color-red">注意：</div>
      <div class="color-red">1.该规则仅针对系统自动合并订单；</div>
      <div class="color-red">2.规则修改保存后，历史订单如果满足自动合并规则会进行再次合并</div>
    
    </div>    
  </div>
    <div slot="footer">
      <el-button type="primary" @click="saveMergeOrderSetting">保存</el-button>
    </div>   
  </el-dialog>
</template>

<script>
import { queryAutoMergeConfigApi } from '@/api/waybillPrint/one688';//tb-1688api
import { queryJdAutoMergeConfigApi } from '@/api/waybillPrint/jdPrint';//jd
import { queryMergeConfigApi } from '@/api/waybillPrint/ksPrint';//ks luban  xhs wxsph
import { queryPddConfigApi } from '@/api/waybillPrint/pddPrint';//pdd

export default {
props: ['platformCode', 'mallCode'],
  data() {
    return {
      loading:true,
      autoFlag:false,
      settingNum:!this.autoFlag?'请选择':2,
      mergeOrderDialogVisible: true
    };
  },
  watch: {
    mergeOrderDialogVisible(val) {
      this.$emit('update:fromParentVisible', val)
    }
  },
  created(){
    this.queryAutoMergeConfigTbFn();
  },
  mounted(){
    //如果autoFlag settingNum有值-》赋值
  },
  methods:{
    
    queryAutoMergeConfigTbFn(){
      let params = {
          "platformCode": this.platformCode,
          "mallCode": this.mallCode
      }   
      //TODO,根据平台判断接口  
      let api ;
      switch(this.platformCode){
        case'JD':api=queryJdAutoMergeConfigApi;break;
        case'ALI_1688':
        case'TAOBAO':api=queryAutoMergeConfigApi;break;

        case'LUBAN':
        case'WXSPH':
        case'XIAOHS':
        case'KS':api=queryMergeConfigApi;break;
        case'PDD':api=queryPddConfigApi;break;
        default:api=queryMergeConfigApi;break;
      } 
      console.log("111",api)
      api(params).then(res=>{
        if(res.message=='ok'&&res.data){
          this.autoFlag = Boolean(res.data.selected);
          this.settingNum = res.data.mergeCount;
        }
      }).finally(()=>{
        this.loading = false;
      })
    },
    autoFlagFn(){
      if(!this.autoFlag){
        this.settingNum = '';
      }else{
        this.settingNum = 2;
      }
    },
    saveMergeOrderSetting(){
      this.$emit("changeAutoMerge",this.autoFlag, this.settingNum);
      this.mergeOrderDialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
  .padding-top-bottom-10{
    padding: 10px 0;
  }
  .font-size-14{
    font-size: 14px;
  }
  .color-red{
    color: #f00;
  }
  .font-weight{
    font-weight: bold;
  }
</style>
